import { createActions } from 'redux-actions';

export const UPDATE = 'UPDATE';

export const options = {
  prefix: 'APP_INFO'
};
export const { update } = createActions(UPDATE, options);
